<template>
  <div id="app">
    <a href="https://mahdif.com/" class="floating_badge" target="_blank">
      <img
        src="@/assets/images/floating_badge_avatar.png"
        alt="Photo of Mahdi Farra"
        srcset="
          @/assets/images/floating_badge_avatar.png,
          @/assets/images/floating_badge_avatar@2x.png 2x
        "
      />
      <div class="badge_text_cont">
        <div class="badge_title">A product by</div>
        <div class="name_in_badge">Mahdi Farra</div>
      </div>
    </a>
    <div v-if="live">
      <router-view v-if="signedIn" />
      <section class="app-loading" v-if="!signedIn">
        <div class="app-loading-cont">
          <div to="/" class="logo_s">
            <img src="@/assets/images/gif_banana_logo_s.svg" alt="" srcset="" />
          </div>
          <div class="line-loading-bar"></div>
        </div>
      </section>
    </div>
    <div class="site_closed_cont" v-else>
      <img
        src="@/assets/images/gif_banana_logo_l.svg"
        alt=""
        class="landing_logo"
        @click="clickCounter++"
      />
      <p>{{ closedMsg }}</p>
    </div>
  </div>
</template>

<script>
// Firebase
import firebaseConfig from "@/components/firebaseConfig.js";
import firebaseConfig_dev from "@/components/firebaseConfig_dev.js";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/analytics";
import "firebase/firebase-auth";

export default {
  data() {
    return {
      signedIn: false,
      live: true,
      closedMsg: "Opening soon",

      clickCounter: 0,

      // Close the app and require password
      betaOn: false,
      isPROD: process.env.NODE_ENV === "production",
    };
  },
  watch: {
    clickCounter: function (val) {
      switch (val) {
        case 0:
          this.closedMsg = "Opening soon";
          break;
        case 10:
          this.closedMsg = "Oh! I guess you know what you're doing";
          break;
        case 15:
          this.closedMsg = "Wow! You never give up";
          break;
        case 20:
          this.closedMsg = "Almost there habibi!";
          break;
        case 30:
          this.closedMsg = "You've activated the app!";
          if (this.checkSecretCode()) {
            this.signIn();
            this.live = true;
            localStorage.setItem(
              "liveState",
              JSON.stringify({ live: true, timestamp: new Date().getTime() })
            );
          }
          this.clickCounter = 0;
          alert("Congratulations! 🎉 You've activated the app for 10 minutes.");
          break;
      }
    },
  },
  created: function () {
    // Initialize Firebase only if it wasn't already
    if (firebase.apps.length === 0) {
      if (this.isPROD) {
        // Load production firebase config
        firebase.initializeApp(firebaseConfig);
      } else {
        firebase.initializeApp(firebaseConfig_dev);
      }
      firebase.analytics();
    }
  },
  methods: {
    signIn() {
      let that = this;
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          // User is signed in.
          that.signedIn = user.isAnonymous;
          that.userId = user.uid;

          // Fetch data from db and track scrolling for infinite scroll
          that.signedIn = true;
        } else {
          // User is signed out.
          console.error("User is signed out");
        }
      });

      firebase
        .auth()
        .signInAnonymously()
        .catch(function (error) {
          // Handle Errors here.
          let errorCode = error.code;
          let errorMessage = error.message;
          console.error("Error while trying to sign in anonymously");
          console.error("Error Code", errorCode);
          console.error("Error Message", errorMessage);
          // ...
        });
    },
    getLiveState() {
      if (this.betaOn) {
        let liveState = localStorage.getItem("liveState");
        liveState = JSON.parse(liveState);
        let timeNow = new Date().getTime();
        // User will get 10 mins from last time activated the app
        if (
          liveState &&
          liveState.live &&
          liveState.timestamp > timeNow - 10 * 60 * 1000
        ) {
          this.live = true;
        } else {
          this.live = false;
        }
      }
    },
    checkSecretCode() {
      let secretCode = prompt("What's the secrt code?", "hmmm...");
      if (btoa(secretCode) === "QmlnIGp1aWN5IHdhdGVybWVsb24=") {
        // Big juicy watermelon
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    this.getLiveState();
    if (this.live) {
      this.signIn();
    }
  },
};
</script>

<style>
/* Import style to be applied on the entire app */
@import "./assets/css/main.css";
</style>
